import { IHttpConnectionOptions } from '@aspnet/signalr';

export type SignalrHub = {
    hubName: string;
    url: string;
    autoReconnect: boolean;
    options?: IHttpConnectionOptions;
};

export type SignalrPriceNotification = {
    productId: number;
    pricelistId: number;
    validFrom: string;
    pricelistPeriodCreated: boolean;
};

export enum CommentType {
    InPrice,
    ExtPrice
}

export type CommentUpdatedNotification = {
    comment: string | null;
    commentType: CommentType;
    priceIds: number[];
    pricelistId: number;
    productId: number;
};

export type AgreementPricesUpdatedNotification = {
    pricelistIds: number[];
    productIds: number[];
    validFrom: string;
    validTo: string;
};

export type PriceActivatedNotification = {
    priceId: number;
    pricelistId: number;
    productId: number;
    isActive: boolean;
    validFrom: string;
};
